export const BaseURL = "https://mindscribebackend.onrender.com";
